const loadState = () => {
  try {
    const serializedState = localStorage.getItem('markazCOB');
    if (serializedState === null) return undefined;
    return JSON.parse(serializedState);
  } catch (err) {
    return undefined;
  }
};

const saveState = (state) => {
  try {
    const serializedState = JSON.stringify(state);
    localStorage.setItem('markazCOB', serializedState);
  } catch (err) {
    return undefined;
  }
};

const localState = {
  loadState,
  saveState,
};

export default localState;
